
import axios from "@/axios-instance"
import moment from "moment"
import { defineComponent } from "vue";
import { useRoute } from "vue-router";
// import useEmitter from '@/useEmitter'
import { emitter } from '@/main';

export default defineComponent({
  name: "kt-widget-5",
  props: {
    // widgetClasses: String,
    dataCustomer: Object as any,
  },
  data() {
    return {
      isEdit: false,
      arrPercent: [{
        label:"Dưới 2 năm",
        value: "max2"
      },{
        label:"Hơn 2 năm và dưới 5 năm",
        value: "2bw5"
      },{
        label:"Trên 5 năm",
        value: "min5"
      },] as any,
      arrGroups: [] as any,
      isstaffchild: false,
      islecturerchild: false,
      ispartnerchild: false,
      personnelchild: null as any,
      typeOption: false,
      typeOption1: false,
      // idStudent: '',
      disableSubmit: false,
      dataCustomerDefault: {} as any
    }
  },
  computed: {
    user() {
      let temp = window.localStorage.getItem("user")
      return temp ? JSON.parse(temp) : null
    },
  },
  components: {
  },
  methods: {
    defaultData() {
      console.log('this.dataCustomerDefault',this.dataCustomerDefault)
      this.islecturerchild = this.dataCustomerDefault.islecturerchild||false
      this.isstaffchild = this.dataCustomerDefault.isstaffchild||false
      this.ispartnerchild = this.dataCustomerDefault.ispartnerchild||false
      this.isEdit = false
    },
    
    async changeEdit() {
      if (this.isEdit) {
        await this.submit()
      }
      this.isEdit = !this.isEdit

    },
    async submit() {
      // if (this.comment == '') {
      //   return
      // }
      this.disableSubmit = true
      let dataTemp = {
        // "idUser": this.user.id,
        // "idStudent": this.idStudent,
        "islecturerchild": this.islecturerchild?this.islecturerchild:null,
        "isstaffchild": this.isstaffchild?this.isstaffchild:null,
        "ispartnerchild": this.ispartnerchild?this.ispartnerchild:null,
        "personnelchild":this.personnelchild
      }
      // console.log('dataTemp',dataTemp)
      // return
      await axios.put(`/admission/student/${this.route.params.id}`, dataTemp)
        .then(({ data }) => {
          this.dataCustomerDefault.islecturerchild = dataTemp.islecturerchild
          this.dataCustomerDefault.isstaffchild = dataTemp.isstaffchild
          this.dataCustomerDefault.ispartnerchild = dataTemp.ispartnerchild
          this.disableSubmit = false
        })
        .catch(({ response }) => {
          console.log('err', response)
        });
    }
  },
  async mounted() {
    // console.log('dataCustomer',this.dataCustomer)
    this.dataCustomerDefault = this.dataCustomer
    this.isstaffchild = this.dataCustomer.isstaffchild
    this.ispartnerchild = this.dataCustomer.ispartnerchild
    this.islecturerchild = this.dataCustomer.islecturerchild
    this.personnelchild = this.dataCustomer.personnelchild
    

  },
  setup () {
    const route = useRoute()
    return {
      route,
    }
  }
});
